/**
 * Recherche placee dans la barre d'outils des collections.
 *
 * Le champ vit A L'INTERIEUR du <form> des filtres : on ne peut donc pas
 * imbriquer un second formulaire, ce serait du HTML invalide et le
 * navigateur le deferait silencieusement. On intercepte donc la validation
 * et on navigue nous-memes, en empechant le formulaire de filtres de partir
 * a notre place.
 *
 * Sur une collection, la recherche reste dans sa categorie : Shopify ne
 * cherche pas dans une collection, mais il filtre une recherche par type de
 * produit. Le snippet pose data-type (Ear Cuff, Faux Piercing Nez) quand la
 * collection n'a qu'un type, et on l'ajoute a l'URL. Sans data-type, la
 * recherche porte sur tout le catalogue.
 */
class RechercheCollection extends HTMLElement {
  #champ = null;
  #bouton = null;

  connectedCallback() {
    this.#champ = this.querySelector('input');
    this.#bouton = this.querySelector('button');
    if (!this.#champ) return;

    this.#champ.addEventListener('keydown', this.#surTouche);
    this.#bouton?.addEventListener('click', this.#surClic);
  }

  disconnectedCallback() {
    this.#champ?.removeEventListener('keydown', this.#surTouche);
    this.#bouton?.removeEventListener('click', this.#surClic);
  }

  #surTouche = (evenement) => {
    if (evenement.key !== 'Enter') return;
    /* Sans cela, Entree soumet le formulaire des filtres et la saisie est
       perdue sans que rien ne se passe. */
    evenement.preventDefault();
    evenement.stopPropagation();
    this.#lancer();
  };

  #surClic = (evenement) => {
    evenement.preventDefault();
    this.#lancer();
  };

  #lancer() {
    const terme = (this.#champ.value || '').trim();
    if (terme.length === 0) {
      this.#champ.focus();
      return;
    }
    const racine = window.Shopify?.routes?.root || '/';
    const type = this.dataset.type;
    const filtre = type ? `&filter.p.product_type=${encodeURIComponent(type)}` : '';
    window.location.assign(`${racine}search?q=${encodeURIComponent(terme)}&type=product${filtre}`);
  }
}

if (!customElements.get('recherche-collection')) {
  customElements.define('recherche-collection', RechercheCollection);
}
